import React from "react";
import Letop from "../allpages/Letop";
import Tip from "../allpages/Tip";

export default () => (
  <div>
    <p>
      <Letop>
        Alle onderstaande vormen worden gemaakt met de{" "}
        <a href="/spqr/leerdoelen/8b">praesensstam</a>.
      </Letop>
    </p>
    <div className="table">
      <table>
        <tr>
          <th className="col bor-bot" />
          <th>praesens</th>
          <th>imperfectum</th>
        </tr>
        <tr>
          <th className="col">1e ev.</th>
          <td>
            {" "}
            <Tip tip="bij a-stammen<br/>valt de a- weg">o</Tip>
          </td>
          <td>ba–m</td>
        </tr>
        <tr>
          <th className="col">2e ev.</th>
          <td>s</td>
          <td>ba–s</td>
        </tr>
        <tr>
          <th className="col">3e ev.</th>
          <td>t</td>
          <td>ba–t</td>
        </tr>
        <tr>
          <th className="col">1e mv.</th>
          <td>mus</td>
          <td>ba–mus</td>
        </tr>
        <tr>
          <th className="col">2e mv.</th>
          <td>tis</td>
          <td>ba–tis</td>
        </tr>
        <tr>
          <th className="col bor-bot">3e mv.</th>
          <td className="bor-bot">nt</td>
          <td className="bor-bot">ba–nt</td>
        </tr>
        <tr>
          <th />
          <td>
            <em>ik eet</em>
          </td>
          <td>
            <em>ik at</em>
          </td>
        </tr>
      </table>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/onv-act-10.js